// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".map-point-selector{pointer-events:all}.map-point-selector__instruction-text{margin-top:10px;margin-bottom:10px}.map-point-selector__current-lat-lon{margin-bottom:20px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
